import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from "../BaseApi";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AttendancePersistSlice = createSlice({
    name: 'attendancePersistService',
    initialState: {
        isAttendanceSupervisor: null
    },
    reducers: {
        // The slice is persisted, so the flag must be dropped when the session ends
        clearAttendanceSupervisor: (state) => {
            state.isAttendanceSupervisor = null;
        },
    },
    extraReducers: {
        'attendancePersistService/isAttendanceSupervisor/fulfilled': (state, action) => {
            state.isAttendanceSupervisor = ResponseApi(action.payload);
        },
    },
});

export const { clearAttendanceSupervisor } = AttendancePersistSlice.actions;

export default AttendancePersistSlice.reducer;
